import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { registerViewsKeys } from '../registerViewKeys'
import { RequestTypes } from '../requestTypes'
import { RegisterTemplate } from '@core/entities/register/RegisterTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteRegisterView = (
  options?: UseMutationOptions<
    RegisterTemplate,
    RequestErrorType,
    RequestTypes['deleteRegisterView']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...registerViewsKeys.deleteRegisterView,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: registerViewsKeys._def })
    },
    ...options,
  })
}
